export default "__VITE_ASSET__B$6qqe3t__"